import { CListGroupItem } from '@coreui/react'
import SearchIcon from '@mui/icons-material/Search'
import { IconButton, Tooltip } from '@mui/material'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { formatPrice } from 'src/utils/commonUtils'
import { formatDates } from 'src/utils/helperFunctions'
import styles from './invoiceentry.module.scss'
import { cls } from 'src/utils/string'

const InvoiceEntry = ({ data, openInvoiceDetails, isAccountPostBill, downloadInvoice }) => {
  const { t } = useTranslation('common')
  const { fruitful_invoice_id, invoicedate, StartDate, EndDate, hdnGrandTotal } = data

  return (
    <CListGroupItem className={styles.cardGroupEntry}>
      <div className={styles.invoiceEntry}>
        <div className={styles.entryStyle}>{formatDates(invoicedate)}</div>
        <div className={styles.entryStyle}>
          {formatDates(StartDate)} to {formatDates(EndDate)}
        </div>
        <div className={cls(styles.entryStyle, styles.total)}>{formatPrice(hdnGrandTotal)}</div>
        <div
          className={styles.entryDownloadStyle}
          onClick={(e) => {
            e.stopPropagation()
            openInvoiceDetails(fruitful_invoice_id)
          }}
        >
          {t('invoices.summary')}
        </div>
        <div className={styles.reportDivStyle}>
          <div
            onClick={() => downloadInvoice(fruitful_invoice_id, invoicedate, !isAccountPostBill)}
          >
            {t('invoices.invoiceBreakdown')}
          </div>
          {isAccountPostBill ? (
            <></>
          ) : (
            <div onClick={() => downloadInvoice(fruitful_invoice_id, invoicedate, true, true)}>
              {t('invoices.priorMonthAdjustmentBreakdown')}
            </div>
          )}
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto',
            justifyItems: 'end',
            width: '100%',
            paddingRight: '5px',
          }}
        >
          <Tooltip title="View Invoice">
            <IconButton
              onClick={(e) => {
                e.stopPropagation()
                openInvoiceDetails(fruitful_invoice_id)
              }}
            >
              <SearchIcon sx={{ fontSize: '1rem' }} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </CListGroupItem>
  )
}

InvoiceEntry.defaultProps = {
  data: {},
  openInvoiceDetails: noop,
  downloadInvoice: noop,
  isAccountPostBill: false,
}

InvoiceEntry.propTypes = {
  data: PropTypes.object,
  openInvoiceDetails: PropTypes.func,
  downloadInvoice: PropTypes.func,
  isAccountPostBill: PropTypes.bool,
}

export default InvoiceEntry
